import { CommonModule } from '@angular/common';
import { Component, effect, EventEmitter, Input, OnInit, Output, Signal, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { Tipos } from 'src/app/auth/register/interfaces/tipos';
import { UsuarioCorreoReq, UsuariosInterface } from '../../../interfaces/usuarios.interface';
import { PersonaInfo } from 'src/app/shared/interfaces/shared-interface';
import { UsuariosService } from '../../../Services/usuarios.service';
import Swal from 'sweetalert2';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-editar-perfil',
  standalone: true,
  imports: [DialogModule, ConfirmDialogModule, FormsModule, ReactiveFormsModule, CommonModule, InputTextModule, TooltipModule],
  templateUrl: './editar-perfil.component.html',
  styleUrl: './editar-perfil.component.scss'
})
export class EditarPerfilComponent implements OnInit {
    @Input() usuarioDialog: boolean=false;

    @Output() onUsuarioDialogChange = new EventEmitter<{openDialog:boolean|any; estadoAccion:boolean|any; submitted:boolean|any}>();
    @Output() closeAndSaveDialogUser = new EventEmitter<{loading:boolean; case:string;}>();
    @Output() onSave = new EventEmitter<{ nombres: string; apellidos: string }>();
    @Output() onClose = new EventEmitter<void>();
    loading = signal(false);
    formEditar: FormGroup;
    @Input() idTipoPersona!: number | null | undefined;
    @Input() usuario!: UsuariosInterface | null;
    @Output() onUsuarioActualizado = new EventEmitter<UsuariosInterface>();
    @Output() onGuardarPerfil = new EventEmitter<{ nombres: string; apellidos: string; correo: string }>();
    @Input() usuarios!: Signal<UsuariosInterface | null>;
    @Input() editarPerfil: boolean = false;
    closeDialogUser() {
        this.usuarioDialog=false;
        this.closeAndSaveDialogUser.emit({loading:this.loading(), case:"close"});
        this.formEditar.reset();
    }
    constructor(private fb: FormBuilder, private usuarioService: UsuariosService){
        this.formEditar = this.nuevoFormEditar();

        effect(() => {
            const user = this.usuarios();
            if (user) {
                this.formEditar.patchValue({
                    correo: user.correo ?? ''
                });
            } else {
            this.formEditar.reset();
            }
        });
    }
    ngOnInit(): void {

    }

    nuevoFormEditar() {
        return this.fb.group({
            nombres: new FormControl<string | null>(null, [Validators.required, Validators.maxLength(500)]),
            apellidos: new FormControl<string | null>(null, [Validators.maxLength(500)]),
            correo: new FormControl<String | null>(null, !this.editarPerfil ? [] : [Validators.required, Validators.email])
        });
    }

    isNit() {
        return this.formEditar.get('tipoDocumento')?.value?.idTipoDocumento == 2
    }

    onConfirmSubmit() {
        if (this.formEditar.invalid) {
            this.formEditar.markAllAsTouched();
            return;
        }

        const payload = this.formEditar.value;
        if(!this.editarPerfil){
            this.onGuardarPerfil.emit(payload);
        }else{
            this.onSave.emit(payload);
        }
        
        this.onClose.emit();
    }

}
